export default __webpack_public_path__ + "static/media/home-page-hero-logo.d007a6de.svg";